function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "lesson-mark",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_1",
  fill: "#4E66C4",
  fillRule: "nonzero",
  cx: 18.5,
  cy: 18.5,
  r: 18.5
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Trazado_132",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  points: "26 12 13 19.9098966 26 27"
})));
function SvgLessonMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lesson-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonMark);
export default __webpack_public_path__ + "static/media/lesson-mark.23c606c4bb6f68558644f86c6067c393.svg";
export { ForwardRef as ReactComponent };